/**
 * Copyright © Veeam Software Group GmbH.
 */


import React from 'react';
import { GridColumnJustify } from '@veeam-vspc/shared/components';

import type { GridColumnProps } from '@veeam-vspc/shared/components';
import type { CompanyStoredVms } from '@veeam-vspc/models/web-controllers';

import { TopsGrid } from '../../../TopsGrid';
import { useCommonSettings } from '../../../../hooks';
import { TopDataUrls } from '../../../../enums';
import { ConfigSectionIds } from 'core/enums';


import type { TopsGridComponentWrapper } from '../../../../interfaces';

export const StoredVMs: React.FC<TopsGridComponentWrapper> = ({ maxNumberOfRows }) => {
    const settings = useCommonSettings<CompanyStoredVms>({ maxNumberOfRows, getDataRequestUrl: TopDataUrls.StoredVMs });
    const { lang } = settings;

    const columns: GridColumnProps<CompanyStoredVms>[] = [
        {
            id: 'companyName',
            title: lang.COMPANY,
            cell: rowData => rowData.companyName,
        },
        {
            id: 'siteName',
            title: lang.SITE,
            cell: rowData => rowData.siteName,
        },
        {
            id: 'cloudVms',
            title: lang.VMS_IN_THE_CLOUD_REPOSITORY,
            cell: rowData => rowData.cloudVms,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
            width: 220,
        },
        {
            id: 'protectedVms',
            title: lang.PROTECTED_VMS,
            cell: rowData => rowData.protectedVms,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },

    ];

    return (
        <TopsGrid
            title={lang.TOP_COMPANIES_BY_PROTECTED_VMS}
            columns={columns}
            sectionId={ConfigSectionIds.TopsCompanies}
            maxNumberOfRows={maxNumberOfRows}
            {...settings}
        />
    );
};
